// extracted by mini-css-extract-plugin
export var one = "styles-module--one--2Aqa9";
export var grid = "styles-module--grid--_vY-s";